var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.089,
    height: 20.164,
    viewBox: "0 0 20.089 20.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.407,20.164H8.358a1.678,1.678,0,0,1-1.673-1.68v-4.2a.836.836,0,1,1,1.673,0v4.2H18.407V1.68H8.358v4.2a.836.836,0,1,1-1.673,0V1.68A1.678,1.678,0,0,1,8.358,0H18.407A1.678,1.678,0,0,1,20.08,1.68v16.8A1.678,1.678,0,0,1,18.407,20.164ZM2.848,9.242H14.215a.84.84,0,0,1,0,1.68H2.848l1.919,1.926a.842.842,0,0,1,0,1.188.834.834,0,0,1-1.183,0L.237,10.677a.843.843,0,0,1-.244-.589s0,0,0-.006,0,0,0-.005a.838.838,0,0,1,.063-.316.852.852,0,0,1,.181-.274l3.346-3.36a.833.833,0,0,1,1.183,0,.842.842,0,0,1,0,1.188Z",
    transform: "translate(0.009)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7d65154a5703f38fdcb15280e89062e7.svg";
export { ForwardRef as ReactComponent };